const EVENTS = [
  // UI Feedback events
  { key: "FRAME_OK", type: "FEEDBACK" },
  { key: "NO_CODE_IN_FRAME", type: "FEEDBACK" },
  { key: "SG_NOT_IN_FRAME", type: "FEEDBACK" },
  { key: "CODE_TOO_BIG", type: "FEEDBACK" },
  { key: "CODE_TOO_SMALL", type: "FEEDBACK" },
  { key: "CODE_IS_BLURRY", type: "FEEDBACK" },
  { key: "CODE_HAS_GLARE", type: "FEEDBACK" },
  // Session ending events
  { key: "AUTH_CANDIDATE_FOUND", type: "END_SESSION" },
  { key: "AUTH_COMPLETE", type: "END_SESSION" },
  { key: "TIMEOUT", type: "END_SESSION" },
  { key: "NO_AUTH_CODE", type: "END_SESSION" },
  { key: "THIRD_PARTY_CODE", type: "END_SESSION" },
  { key: "CODE_NOT_FOUND", type: "END_SESSION" },
  { key: "SDK_ERROR", type: "END_SESSION" },
  { key: "ERROR", type: "END_SESSION" },

  // Init session event
  { key: "INIT", type: "START_SESSION" }
];

export default EVENTS;
